// store/index.js

import { createStore } from 'vuex';
import progress from './progress';

export default createStore({
  modules: {
    progress,
  },
});
